import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import themeMod from './../../styles/theme/MUItheme'

const styles = () => ({
    root: {
        top: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
});

class Dashboard extends React.Component {
    render() {
        const { classes, position, children, hideScrollbar = false } = this.props;

        return (
            <MuiThemeProvider theme={themeMod}>
                <CssBaseline />
                <div className={classes.root} style={{ position: position, overflow: hideScrollbar ? 'hidden' : 'none' }}>
                    <main>{children}</main>
                </div>
            </MuiThemeProvider>
        )
    }
}

export default withStyles(styles)(Dashboard);